import { Injectable } from "@angular/core";
import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import { HttpResponse } from "@sitecore-jss/sitecore-jss-angular";
import { Observable, lastValueFrom, BehaviorSubject } from "rxjs";

@Injectable()
export class JssDataFetcherService {
    constructor(private readonly httpClient: HttpClient) {
        this.fetch = this.fetch.bind(this);
    }
    protected _showLoader: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(null);
    public showLoader$ = this._showLoader.asObservable();

    fetch<T>(url: string, data: unknown, withLoader: boolean = false, headers?: Record<string, string>): Promise<HttpResponse<T>> {
        let result: Observable<T>;

        const options: { withCredentials: boolean; headers?: Record<string, string>; observe: "body"; responseType: "json" } = {
            withCredentials: true,
            observe: "body",
            responseType: "json",
        };

        if (headers) {
            options.headers = headers;
        }

        if (withLoader) {
            this._showLoader.next(true);
        }
        if (data) {
            result = this.httpClient.post<T>(url, data, options);
        } else {
            result = this.httpClient.get<T>(url, options);
        }

        return lastValueFrom(result)
            .then((responseData) => ({
                data: responseData as T,
                status: 200,
                statusText: "OK",
            }))
            .catch((error: HttpErrorResponse) => {
                if (error instanceof Error) {
                    throw error;
                }

                return {
                    data: error.error as T,
                    status: error.status,
                    statusText: error.statusText,
                };
            });
    }
}
